import { useEffect } from 'react';
import { useSiteVisitRecordingStore } from '@store/siteVisitRecordingStore';

/** Show pause reminder when the user edits this visit form while recording is paused. */
export function useShowPauseReminderOnVisitFormEdit(): void {
	useEffect(() => {
		const onFormEdit = (): void => {
			useSiteVisitRecordingStore.getState().notifyPausedFormEdit();
		};

		const onNonNativeFormEdit = (event: Event): void => {
			const target = event.target as Element | null;
			if (target?.closest('.dropdown-item, .purchas-btn')) {
				onFormEdit();
			}
		};

		document.addEventListener('input', onFormEdit, true);
		document.addEventListener('change', onFormEdit, true);
		document.addEventListener('mousedown', onNonNativeFormEdit, true);

		return (): void => {
			document.removeEventListener('input', onFormEdit, true);
			document.removeEventListener('change', onFormEdit, true);
			document.removeEventListener('mousedown', onNonNativeFormEdit, true);
		};
	}, []);
}
